/**
 * The supported format string tokens that can be used with Date-fns v2.x
 * Adheres to the format tokens provided by https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table.
 */
export var UnicodeDateFormatterToken;
(function (UnicodeDateFormatterToken) {
    UnicodeDateFormatterToken["MonthNumeric"] = "L";
    UnicodeDateFormatterToken["MonthOrdinal"] = "Mo";
    UnicodeDateFormatterToken["MonthTwoDigit"] = "LL";
    UnicodeDateFormatterToken["MonthShort"] = "LLL";
    UnicodeDateFormatterToken["MonthLong"] = "LLLL";
    UnicodeDateFormatterToken["QuarterNumeric"] = "q";
    UnicodeDateFormatterToken["QuarterOrdinal"] = "qo";
    UnicodeDateFormatterToken["DayOfMonthNumeric"] = "d";
    UnicodeDateFormatterToken["DayOfMonthOrdinal"] = "do";
    UnicodeDateFormatterToken["DayOfMonthTwoDigit"] = "dd";
    UnicodeDateFormatterToken["DayOfYearNumeric"] = "D";
    UnicodeDateFormatterToken["DayOfYearOrdinal"] = "Do";
    UnicodeDateFormatterToken["DayOfYearThreeDigit"] = "DDD";
    UnicodeDateFormatterToken["DayOfWeekZeroIndexed"] = "d";
    UnicodeDateFormatterToken["DayOfWeekOrdinal"] = "io";
    UnicodeDateFormatterToken["DayOfWeekTwoChar"] = "iiiiii";
    UnicodeDateFormatterToken["DayOfWeekShort"] = "iii";
    UnicodeDateFormatterToken["DayOfWeekLong"] = "iiii";
    UnicodeDateFormatterToken["DayOfWeekNumeric"] = "i";
    UnicodeDateFormatterToken["WeekOfYearNumeric"] = "I";
    UnicodeDateFormatterToken["WeekOfYearOrdinal"] = "Io";
    UnicodeDateFormatterToken["WeekOfYearTwoDigit"] = "II";
    UnicodeDateFormatterToken["YearTwoDigit"] = "yy";
    UnicodeDateFormatterToken["YearNumeric"] = "yyyy";
    UnicodeDateFormatterToken["YearWeekNumberingTwoDigit"] = "RR";
    UnicodeDateFormatterToken["YearWeekNumberingNumeric"] = "RRRR";
    UnicodeDateFormatterToken["Hour24Numeric"] = "H";
    UnicodeDateFormatterToken["Hour24TwoDigit"] = "HH";
    UnicodeDateFormatterToken["Hour12Numeric"] = "h";
    UnicodeDateFormatterToken["Hour12TwoDigit"] = "hh";
    UnicodeDateFormatterToken["MinuteNumeric"] = "m";
    UnicodeDateFormatterToken["MinuteTwoDigit"] = "mm";
    UnicodeDateFormatterToken["SecondNumeric"] = "s";
    UnicodeDateFormatterToken["SecondTwoDigit"] = "ss";
    UnicodeDateFormatterToken["SecondTenth"] = "S";
    UnicodeDateFormatterToken["SecondHundredth"] = "SS";
    UnicodeDateFormatterToken["Millisecond"] = "SSS";
    UnicodeDateFormatterToken["MeridiemUpperCase"] = "aa";
    UnicodeDateFormatterToken["MeridiemLowerCase"] = "aa";
    UnicodeDateFormatterToken["MeridiemFull"] = "aaaa";
    UnicodeDateFormatterToken["Offset"] = "xxx";
    UnicodeDateFormatterToken["OffsetWithoutSeparator"] = "xx";
    UnicodeDateFormatterToken["TimestampSeconds"] = "t";
    UnicodeDateFormatterToken["TimestampMilliseconds"] = "T";
})(UnicodeDateFormatterToken || (UnicodeDateFormatterToken = {}));
//# sourceMappingURL=unicode-date-formatter-token.js.map